/**
 * Darstellung hell/dunkel/System. Gespeichert nur im Browser (localStorage),
 * umgeschaltet über `data-theme` am `<html>`; „System" entfernt das Attribut
 * und überlässt es `prefers-color-scheme` (styles.css).
 */
export type ThemeChoice = 'system' | 'light' | 'dark';

const KEY = 'dashy-dash.theme';

export function storedTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset.theme;
  else root.dataset.theme = choice;
}

export function setTheme(choice: ThemeChoice): void {
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    /* privates Fenster o. Ä.: gilt dann nur bis zum Neuladen */
  }
  applyTheme(choice);
}

// Beim Laden der App anwenden: routes.tsx importiert die Seite und damit dieses Modul.
applyTheme(storedTheme());
